export enum Brand {
    QA,
    PFIVerify,
    GetPFIVerify,
    Financeify,
    GetFinanceify,
    VerifyFinancialProfile,
    Finsights,
    PFISimplify,
    PFIVerifyDOVentures,
    MyFinanceifyDOVentures,
    PFMVerify,
    FinancialInsight,
}